import { deleteApi, getApi, postApi, putApi } from "../services/axios";
import APIs from ".";

export function getHolidays(params: {
  year?: number | string;
  type?: string;
  countryCode?: string;
  active?: boolean | string;
  page?: number;
  limit?: number;
} = {}) {
  return async function () {
    const res = await getApi(APIs.HOLIDAYS.LIST(params), {
      validateUser: true,
      skipGlobalLoading: true,
    });
    return res;
  };
}

export function createHoliday(payload) {
  return async function () {
    const res = await postApi(APIs.HOLIDAYS.CREATE, payload, {
      validateUser: true,
      skipGlobalLoading: true,
    });
    return res;
  };
}

export function updateHoliday(holidayId, payload) {
  return async function () {
    const res = await putApi(APIs.HOLIDAYS.UPDATE(holidayId), payload, {
      validateUser: true,
      skipGlobalLoading: true,
    });
    return res;
  };
}

export function deleteHoliday(holidayId) {
  return async function () {
    const res = await deleteApi(
      APIs.HOLIDAYS.DELETE(holidayId),
      {},
      {
        validateUser: true,
        skipGlobalLoading: true,
      }
    );
    return res;
  };
}

export function syncHolidays(payload: { countryCode?: string } = {}) {
  return async function () {
    const res = await postApi(APIs.HOLIDAYS.SYNC, payload, {
      validateUser: true,
      skipGlobalLoading: true,
    });
    return res;
  };
}
